import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { DESKTOP_STEPS } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/DesktopUploadWizzard/DesktopUploadWizzard.consts';
import { MOBILE_STEPS } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/MobileUploadWizzard/MobileUploadWizzard.consts';
import { useStores } from '@/hooks/use-stores';
import { useResponsive } from '@/hooks/useResponsive';
import { MAX_IMAGE_UPLOAD_COUNT } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/ImageUpload.consts';

import { ImageUploadContainer } from './ImageUpload.styles';

const ImageUpload = observer(({ deviceId }: { deviceId: string }) => {
  const { t } = useTranslation();
  const { imageUploadStore, devicesStore } = useStores();
  const { isMobile } = useResponsive();
  const STEPS = isMobile ? MOBILE_STEPS : DESKTOP_STEPS;
  const currentStep =
    imageUploadStore.currentStep <= STEPS.length - 1 ? imageUploadStore.currentStep : imageUploadStore.currentStep - 1;

  const { label, component: Step } = STEPS[currentStep];

  const onComplete = async () => {
    await devicesStore.saveDeviceImages(deviceId, imageUploadStore.images);
    imageUploadStore.reset();
    imageUploadStore.setMaxFiles(MAX_IMAGE_UPLOAD_COUNT - (devicesStore.deviceImages?.length || 0));
  };

  return (
    <ImageUploadContainer $isFirstStep={imageUploadStore.currentStep === 0} $isMobile={isMobile}>
      {!isMobile && <p className="title">{t(label)}</p>}
      <Step
        onComplete={onComplete}
        layout={isMobile ? 'mobile' : 'desktop'}
        loading={devicesStore.isSavingDeviceImages}
      />
    </ImageUploadContainer>
  );
});

export default ImageUpload;
